import React, { useState } from "react";
import { TabPanel, MainGameTab } from "../../components/common/MainGameTab";
import GameCard from "./GameCard";

export default function GameTabs({ tabsData, tabStyle }) {
  const [activeTab, setActiveTab] = useState(0);
  
  // Add more detailed debugging
  console.log("GameTabs received tabsData:", tabsData);
  
  if (!tabsData || tabsData.length === 0) {
    console.warn("GameTabs received empty or null tabsData");
    return (
      <div className="px-4">
        <p className="text-center text-gray-500 p-4">Waiting for game data...</p>
      </div>
    );
  }
  
  // Check each tab for cards
  tabsData.forEach((tab, i) => {
    // console.log(`Tab ${i} (${tab.title}):`, tab);
    // console.log(`Tab ${i} cards:`, tab.cards ? `${tab.cards.length} cards` : 'no cards array');
    if (tab.cards && tab.cards.length > 0) {
      // console.log(`First card in ${tab.title}:`, tab.cards[0]);
    }
  });

  // For testing - render all cards outside of tabs
  const allCards = tabsData.reduce((acc, tab) => {
    if (tab.cards && tab.cards.length > 0) {
      return [...acc, ...tab.cards];
    }
    return acc;
  }, []);
  
  const handleTabChange = (index) => {
    console.log("Tab changed to:", index);
    setActiveTab(index);
  };
  
  return (
    <div className="px-4">
      <MainGameTab
        tabStyle="flex border-b space-x-2.5 text-xs border-[#E1E7EF] overflow-x-auto hide-scrollbar"
        activeClass="text-[#0E64D1] px-2 pb-4 border-b-2 border-[#0E64D1] whitespace-nowrap"
        inactiveClass="text-[#12131A] px-2 pb-4 whitespace-nowrap"
        activeTab={activeTab}
        onTabChange={handleTabChange}
      >
        {tabsData.map((tab, index) => (
          <TabPanel key={index} title={tab.title}>
            <div 
              className="space-y-3 p-3 overflow-y-auto hide-scrollbar" 
              style={{ height: 'calc(100vh - 150px)' }}
            >
              {/* More detailed debugging */}
              {/* {console.log(`Rendering Tab ${index} (${tab.title}) cards:`, tab.cards)} */}
              
              {!tab.cards ? (
                <div className="flex justify-center items-center h-48 text-gray-500">
                  Error: Cards array is missing for this tab
                </div>
              ) : tab.cards.length > 0 ? (
                tab.cards.map((card, idx) => {
                  // console.log(`Rendering card ${idx} in tab ${tab.title}:`, card);
                  return (
                    <GameCard
                      key={idx}
                      icon={card.icon}
                      title={card.title}
                      doubleWin={card.doubleWin}
                      tripleWin={card.tripleWin}
                      prize={card.prize}
                      percentage={card.percentage}
                      id={card.id}
                      description={card.description}
                      price={card.price}
                      gameType={card.gameType}
                    />
                  );
                })
              ) : (
                <div className="flex justify-center items-center h-48 text-gray-500">
                  No games available in this category
                </div>
              )}
            </div>
          </TabPanel>
        ))}
      </MainGameTab>
      
      {/* Debug section - uncomment to see all cards outside of tabs */}
      {/* <div className="mt-8 border-t-2 pt-4">
        <h3 className="text-sm font-bold mb-2">All Cards (Debug):</h3>
        <div className="space-y-3">
          {allCards.map((card, idx) => (
            <GameCard
              key={`debug-${idx}`}
              icon={card.icon}
              title={card.title}
              doubleWin={card.doubleWin}
              tripleWin={card.tripleWin}
              prize={card.prize}
              percentage={card.percentage}
              id={card.id}
              description={card.description}
              price={card.price}
            />
          ))}
        </div>
      </div> */}
    </div>
  );
}
